import { get, post } from "./../Config/config";
export const WhatsappTemplatesAPI = {
  get: (data) =>
    get("/whatsapp-meta-templates/list?approved=true", { params: data }),
  getTemplateList: (data) =>
    get("/whatsapp-meta-templates/list", { params: data }),
  add: (data) => post("/whatsapp-meta-templates/create", data),
  sendTemplateForChat: (data) => post("/whatsapp-templates/message/send", data),
  SendMultiSendTemplate: (data) =>
    post("/whatsapp-templates/message/multisend", data),
  getLeadWhatsappList: (data) =>
    get("whatsapp/beta/lead-list", { params: data }),
  WhatsappLeadConverter: (data) => post("whatsapp/beta/lead-list/update", data),
  viewTemplate: (data) => get(`/whatsapp-meta-templates/view/${data.name}`),
  // WhatsApp Conversation API
  getMessagesList: (data) => get(`/whatsapp/beta/message/list/${data.lead_id}`),
  sentMessage: (data) => post("/whatsapp/beta/message/send", data),
  addConversation: (data) => post("/whatsapp-conversations/create", data),
  getRecendCommunications: (data) =>
    get("whatsapp/beta/communications/list", { params: data }),
  getTemplateDetails: (data) => get(`/whatsapp-meta-templates/view/${data?.id}`), 
  addToFavorites: (data) => post(`/whatsapp/beta/toggle-favorite/${data.lead_id}`),
};
   